//////////////////////////////////////////////////////////////////////
//
//  09/20/18
//  src/store/index.js
//
//  This file configures the reducer.
//
//  Note about Thunk:
//  By default, Redux action creators don't support asynchronous actions
//  like fetch data, so here's where we utilise Redux Thunk.  Thunk allows
//  you to write action creators that return a function instead of an action.
//

import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";  // Thunk allows asynchronous call in the 'Redux' way.
import rootReducer from "./reducers";

export function configureStore() {
  const store = createStore( 
    rootReducer, 
    compose( 
      applyMiddleware( thunk ),
// I did this in another class.      
//    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() 
// This class did this.  Not sure what the difference is but if I used the above
// then this code ran in Chrome but did not in FireFox.  When I swapped out with the
// below then it worked in both.
      window.devToolsExtension ? window.devToolsExtension() : f => f
    )
  );

  return store;
}



// WEBPACK FOOTER //
// ./src/store/index.js